import styled from 'styled-components';

export const ManageLanguagesModalContainer = styled.div``;

export const ManageLanguagesModalLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .loading-placeholder-language {
    margin-bottom: 10px;
  }
`;

export const ManageLanguagesModalDescription = styled.h3`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  margin-bottom: 8px;

  .glyphicon-info-sign {
    margin-left: 8px;
  }
`;

export const AutoTranslationContainer = styled.div`
  margin-top: 20px;
`;
